import RestoreFromTrashRoundedIcon from "@material-ui/icons/RestoreFromTrashRounded";
import { getAllBrands, deleteAndRestoreBrand } from "../../reduxSaga/actions";
import { useSelector, useDispatch } from "react-redux";
import AddBrand from "../../ui/AddBrand";
import { useEffect, useState } from "react";
import EditBrand from "../../ui/EditBrand";
import { useNavigate } from "react-router-dom";
import getCurrentUserId from "../../reduxSaga/sagas/requests/currentUserId";
import CashRegisterService from "../../services/ProductSellBToC/CashRegisterService";
import UtilsFormule from "../../utils/UtilsFormule";
import AddCaisse from "../../ui/AddCaisse";
const Shop = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [oldBrandData, setOldBrandData] = useState();
  const [availableShop, setAvailableShop] = useState([]);
  const [onAddCashRegister, setOnAddCashRegister] = useState(false);
  const [userRole, setUserRole] = useState("");

  useEffect(() => {
    if (localStorage.getItem("status") == null) {
      setUserRole(["notConnected"]);
    } else {
      setUserRole(JSON.parse(localStorage.getItem("status")));
    }
    CashRegisterService.getAllShop(getCurrentUserId())
      .then((response) => {
        if (response.data.success) {
          setAvailableShop(response.data.success);
        } else {
          console.log("error in getAllShop", response.data.success);
        }
      })
      .catch((e) => {
        console.log("error in getAllShop", e);
      });
  }, []);

  const onAddShopHandler = () => {
    navigate(`/ajoutermagasins`);
  };

  const onArchiveHandler = (brandId, archiveOrRestored) => {
    let deletedAndRestoreModel = {
      idBrand: brandId,
      isDeleted: archiveOrRestored,
    };
    dispatch(deleteAndRestoreBrand(deletedAndRestoreModel));
  };

  const onVoirTicketsMagasin = (id,ref,name) => {
            localStorage.setItem("nameDetailsTicketMagasin", name);

    localStorage.setItem("idDetailsTicketMagasin", id);
    window.open("/tickets-magasin", "_blank");
  };

   const onVoirCreditMagasin = (id,ref,name) => {
        localStorage.setItem("nameDetailsTicketMagasin", name);

    localStorage.setItem("idDetailsTicketMagasin", id);
    window.open("/credit-magasin", "_blank");
  };

     const onVoirTraiteMagasin = (id,ref,name) => {
        localStorage.setItem("nameDetailsTicketMagasin", name);

    localStorage.setItem("idDetailsTicketMagasin", id);
    window.open("/traite-magasin", "_blank");
  };
  const onVoirManagersMagasin = (id) => {
    localStorage.setItem("idMagasinManagers", id);
    window.open("/managers-magasin", "_blank");
  };
  const onVoirJournauxCaisses = (id) => {
    localStorage.setItem("idShopJournaux", id);
    localStorage.setItem("typeGetJournaux", "shop");
    window.open("/journal-caisse", "_blank");
  };
  return (
    <div className="content-wrapper" style={{ marginTop: "0" }}>
      <div className="content ">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-12">
              <div class="card  mt-3">
                <div class="card-body">
                  <h5 class="card-title">Les magasins</h5>

                  <button
                    class="btn btn-dark float-right"
                    // data-toggle="modal"
                    // data-target="#add-brand"
                    onClick={onAddShopHandler}
                  >
                    <i class="fas fa-plus"></i>
                  </button>
                </div>
              </div>
              <section class="content">
                <div class="card">
                  <div class="card-header  ">
                    <h3 class="card-title">Les magasins</h3>
                    <div class="card-tools">
                      <button
                        type="button"
                        class="btn btn-tool"
                        data-card-widget="collapse"
                        title="Collapse"
                      >
                        <i class="fas fa-minus"></i>
                      </button>
                    </div>
                  </div>
                  <div class="card-body p-0">
                    <table class="table  projects">
                      <thead>
                        <tr>
                          <th>Libellé</th>
                          <th style={{ width: "12%" }}>DC</th>
                          
                          <th className="text-center" style={{ width: "12%" }}>
                            Les Tickets
                          </th>{" "}
                          <th className="text-center" style={{ width: "12%" }}>
                            Le credit
                          </th>
                           <th className="text-center" style={{ width: "12%" }}>
                            Les traites
                          </th>
                          {userRole.includes("ADMIN") && (
                            <th
                              className="text-center"
                              style={{ width: "12%" }}
                            >
                              Les journaux
                            </th>
                          )}
                          {userRole.includes("ADMIN") && (
                            <th
                              className="text-center"
                              style={{ width: "12%" }}
                            >
                              Les Responsables
                            </th>
                          )}
                          <th className="text-center" style={{ width: "12%" }}>
                            Archiver
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {availableShop &&
                          availableShop.map((element, i) => (
                            <tr key={element.id}>
                              <td>
                                {element.ref}-{element.name}
                              </td>

                              <td>
                                {UtilsFormule.formatDate(element.creationDate)}
                              </td>

                              {/* <td className="text-center">
                                <button
                                  style={{ width: 40 }}
                                  class="btn bg-gray btn-sm "
                                  data-toggle="modal"
                                  data-target="#edit-brand"
                                  // onClick={() =>
                                  //   // onEditBrandHandler(
                                  //   //   element.id,
                                  //   //   element.name,
                                  //   //   element.description
                                  //   // )
                                  // }
                                >
                                  <i class="fas fa-pencil-alt"></i>
                                </button>
                              </td> */}

                              {/* <td className="text-center">
                                <button
                                  style={{ width: 40 }}
                                  class="btn bg-black btn-sm "
                                  onClick={() =>
                                    onViewProductsHandler(
                                      element.id,
                                      element.name
                                    )
                                  }
                                >
                                  <i class="fas fa-shopping-cart"></i>
                                </button>
                              </td> */}

                              <td className="text-center">
                                <button
                                  style={{ width: 40 }}
                                  class="btn btn-dark btn-sm"
                                  onClick={() =>
                                    onVoirTicketsMagasin(element.id,element.ref,element.name)
                                  }
                                >
                                  <i class="fas fa-ticket"></i>
                                </button>
                              </td>
                              <td className="text-center">
                                <button
                                  style={{ width: 40 }}
                                  class="btn btn-dark btn-sm"
                                  onClick={() =>
                                    onVoirCreditMagasin(element.id,element.ref,element.name)
                                  }
                                >
                                  <i class="fas fa-ticket"></i>
                                </button>
                              </td>
                                 <td className="text-center">
                                <button
                                  style={{ width: 40 }}
                                  class="btn btn-dark btn-sm"
                                  onClick={() =>
                                    onVoirTraiteMagasin(element.id,element.ref,element.name)
                                  }
                                >
                                  <i class="fas fa-money-bill"></i>
                                </button>
                              </td>
                              {userRole.includes("ADMIN") && (
                                <td className="text-center">
                                  <button
                                    style={{ width: 40 }}
                                    class="btn btn-dark btn-sm"
                                    onClick={() =>
                                      onVoirJournauxCaisses(element.id)
                                    }
                                  >
                                    <i class="fas fa-book"></i>
                                  </button>
                                </td>
                              )}
                              {userRole.includes("ADMIN") && (
                                <td className="text-center">
                                  <button
                                    style={{ width: 40 }}
                                    class="btn btn-dark btn-sm"
                                    onClick={() =>
                                      onVoirManagersMagasin(element.id)
                                    }
                                  >
                                    <i class="fas fa-users"></i>
                                  </button>
                                </td>
                              )}
                              <td className="text-center">
                                <button
                                  style={{ width: 40 }}
                                  class="btn btn-danger btn-sm"
                                  onClick={() =>
                                    onArchiveHandler(element.id, 1)
                                  }
                                >
                                  <i class="fas fa-trash"></i>
                                </button>
                              </td>
                            </tr>
                          ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </div>
      </div>
      {onAddCashRegister && (
        <AddCaisse setOnAddCashRegister={setOnAddCashRegister} />
      )}
    </div>
  );
};
export default Shop;
